import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {
  Action,
  createAction,
  createReducer,
  props,
  on,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import {ISousSysteme} from '../../_models/SousSysteme';

export const name = 'sousSystemes';

export interface SousSystemeState extends EntityState<ISousSysteme> {
  selectedId: number | null;
  isInitialized: boolean;
  isLoading: boolean;
}

function selectSousSysteme(a: ISousSysteme): any {
  return a.id;
}

function sortById(a: ISousSysteme, b: ISousSysteme): number {
  if (a.id < b.id) {
    return -1;
  } else if (a.id > b.id) {
    return 1;
  } else {
    return 0;
  }
}

const adapter: EntityAdapter<ISousSysteme> = createEntityAdapter<ISousSysteme>({
  selectId: selectSousSysteme,
  sortComparer: sortById,
});

const initialState: SousSystemeState = adapter.getInitialState({
  selectedId: null,
  isInitialized: false,
  isLoading: false,
});

/* ACTION */
export const loadSousSystemesAction = createAction(
  '[SousSysteme] Load SousSystemes'
);
export const loadSousSystemesSuccessAction = createAction(
  '[SousSysteme] Load SousSystemes Success',
  props<{ payload: ISousSysteme[] }>()
);
export const loadSousSystemesErrorAction = createAction(
  '[SousSysteme] Load SousSystemes Error'
);
export const setSousSystemesSuccessAction = createAction(
  '[SousSysteme] Set SousSystemes Success',
  props<{ payload: ISousSysteme[] }>()
);

/* REDUCER */
const reducer = createReducer(
  initialState,
  on(loadSousSystemesAction, (state) => {
    return {...state, isLoading: true};
  }),
  on(loadSousSystemesErrorAction, (state) => {
    return {...state, isLoading: false};
  }),
  on(loadSousSystemesSuccessAction, (state, {payload}) => {
    return adapter.setAll(payload, {
      ...state,
      isInitialized: true,
      isLoading: false,
    });
  }),
  on(setSousSystemesSuccessAction, (state, {payload}) => {
    return adapter.setAll(payload, state);
  }),
);

export function sousSystemeReducer(
  state: SousSystemeState | undefined,
  action: Action
): SousSystemeState {
  return reducer(state, action);
}

/* SELECTOR */
const selectSousSystemeState = createFeatureSelector<SousSystemeState>(name);

const isInitialized = (state: SousSystemeState) => state.isInitialized;
const isLoading = (state: SousSystemeState) => state.isLoading;

export const {selectIds, selectEntities, selectAll, selectTotal} =
  adapter.getSelectors();

export const getAllSousSystemes = createSelector(
  selectSousSystemeState,
  selectAll
);
export const getIsSousSystemeInitialized = createSelector(
  selectSousSystemeState,
  isInitialized
);
export const getIsSousSystemeLoading = createSelector(
  selectSousSystemeState,
  isLoading
);
